export default function SSE(response) {
  const decoder = new TextDecoder()
  const listeners = []
  let buffer = ''
  let isFinished = false

  const emit = (event, payload) => listeners.filter(l => l.event === event).forEach(l => l.callback(payload))

  const finish = () => {
    if (isFinished) return
    isFinished = true
    emit('finished')
  }

  const handle = block => {
    const data = block
      .split('\n')
      .filter(line => line.startsWith('data:'))
      .map(line => line.replace(/^data: ?/, ''))
      .join('\n')

    if (!data) return

    let parsed
    try {
      parsed = JSON.parse(data)
    } catch (err) {
      return
    }

    emit(parsed.event, parsed.payload)
  }

  const reader = response.body.getReader()

  reader
    .read()
    .then(function Consume({ done, value }) {
      if (value) buffer += decoder.decode(value, { stream: true })

      const blocks = buffer.split('\n\n')
      buffer = blocks.pop()
      blocks.forEach(handle)

      if (!done) return reader.read().then(Consume)

      handle(buffer + decoder.decode())
      finish()
    })
    .catch(err => {
      emit('error', { message: err.message })
      finish()
    })

  return {
    on: (event, callback) => {
      listeners.push({ event, callback })
    },
    cancel: () => {
      reader.cancel()
    },
  }
}
